export class ConfigUrl{
    static readonly host:string = 'https://ticket-api.hwpd.go.th/api/v1';
}